/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AccountingConfigurationDto {
  /**
   * @minLength 0
   * @maxLength 4
   */
  vkBur?: string;
  /**
   * @minLength 0
   * @maxLength 4
   */
  vkOrg?: string;
}

export interface AddressDto {
  /** @example "b" */
  addition?: string;
  /**
   * @minLength 1
   * @example "Hamburg"
   */
  city: string;
  /**
   * Country code in ISO-3166-1 ALPHA-2 format
   * @minLength 1
   * @example "DE"
   */
  country: string;
  /**
   * @minLength 1
   * @example "1"
   */
  houseNumber: string;
  /**
   * @minLength 1
   * @example "22089"
   */
  postCode: string;
  /**
   * @minLength 1
   * @example "Wartenau"
   */
  street: string;
}

export interface AuditInfoDto {
  /**
   * @minLength 1
   * @example "system"
   */
  createdBy: string;
  /** @format date-time */
  createdDate: string;
  /**
   * @minLength 1
   * @example "system"
   */
  lastModifiedBy: string;
  /** @format date-time */
  lastModifiedDate: string;
  /**
   * @format int64
   * @example 1
   */
  version: number;
}

export interface CustomerConfigurationDto {
  accountingConfiguration?: AccountingConfigurationDto;
  fulfilmentMaximumVehiclesPerDeliveryMethod?: FulfilmentMaximumVehiclesPerDeliveryMethodDto;
  /** @uniqueItems true */
  shipmentReadyConfiguration?: ShipmentReadyConfigurationDto[];
  shippingConfiguration?: ShippingConfigurationDto;
  statisticsConfiguration?: StatisticsConfigurationDto;
  storageCabinets?: string[];
  /** @format uuid */
  storageWarehouseId?: string;
  /** @format int64 */
  version?: number;
}

export interface CustomerDataDto {
  /**
   * Indikator ob Kunde aktiv
   * @example true
   */
  active: boolean;
  address: AddressDto;
  /**
   * SAP Kundenummer (10 Stellig)
   * @minLength 10
   * @maxLength 10
   * @example "9999999999"
   */
  customerNumber: string;
  /**
   * Anzeigename
   * @minLength 1
   * @example "Max AG (Hamburg)"
   */
  displayName: string;
  /**
   * Firmenname
   * @minLength 1
   * @example "Max AG"
   */
  name: string;
}

export interface CustomerDetailDto {
  audit?: AuditInfoDto;
  data: CustomerDataDto;
}

export interface CustomerEventDto {
  audit: AuditInfoDto;
  configuration?: CustomerConfigurationDto;
  data: CustomerDataDto;
  /**
   * Id
   * @format uuid
   */
  id: string;
}

export interface CustomerListDto {
  items?: CustomerListItemDto[];
  /** @format int32 */
  totalPages?: number;
}

export interface CustomerListItemDto {
  active?: boolean;
  customerNumber?: string;
  displayName?: string;
  /** @format uuid */
  id?: string;
  name?: string;
}

export enum DefaultShipmentProcessTypeDto {
  REGULAR = "REGULAR",
  INTERNAL = "INTERNAL",
  STORAGE_TRANSFER = "STORAGE_TRANSFER",
  STORAGE_TRANSFER_SCA = "STORAGE_TRANSFER_SCA",
  STORAGE_TRANSFER_SCA_FINISH = "STORAGE_TRANSFER_SCA_FINISH",
  MVR_ON = "MVR_ON",
  MVR = "MVR",
}

export enum DefaultShipmentTypeDto {
  MORNING = "MORNING",
  LATE_MORNING = "LATE_MORNING",
  NOON = "NOON",
  TRACKED = "TRACKED",
}

export enum DefaultShippingDestinationTypeDto {
  DOMESTIC = "DOMESTIC",
  EU = "EU",
  NON_EU = "NON_EU",
}

export interface FieldValidationDto {
  code?: string;
  field?: string;
  message?: string;
}

export interface FulfilmentMaximumVehiclesPerDeliveryMethodDto {
  /**
   * @format int32
   * @min 1
   */
  lateMorning?: number;
  /**
   * @format int32
   * @min 1
   */
  morning?: number;
  /**
   * @format int32
   * @min 1
   */
  noon?: number;
  /**
   * @format int32
   * @min 1
   */
  post?: number;
  /**
   * @format int32
   * @min 1
   */
  tracked?: number;
}

export interface ResourceCreatedDto {
  /** @format uuid */
  id?: string;
}

/**
 * Aktion
 * @example "DESTROY"
 */
export enum ScanDocumentRuleActionTypeDto {
  DESTROY = "DESTROY",
}

/** Regeldaten */
export interface ScanDocumentRuleDataDto {
  /** Aktion */
  action: ScanDocumentRuleActionTypeDto;
  /** Feldname */
  field: ScanDocumentRuleFieldTypeDto;
  /**
   * Regelname
   * @minLength 1
   * @example "ZB I drop"
   */
  name: string;
  /**
   * Feldwert
   * @minLength 1
   * @example "COR_I"
   */
  value: string;
}

export interface ScanDocumentRuleDetailDto {
  /** Regeldaten */
  data: ScanDocumentRuleDataDto;
}

/**
 * Feldname
 * @example "DOCUMENT_TYPE"
 */
export enum ScanDocumentRuleFieldTypeDto {
  DOCUMENT_TYPE = "DOCUMENT_TYPE",
}

export interface ScanDocumentRulesListDto {
  items?: ScanDocumentRulesListItemDto[];
  /** @format int32 */
  totalPages?: number;
}

export interface ScanDocumentRulesListItemDto {
  /** Aktion */
  action?: ScanDocumentRuleActionTypeDto;
  /** @format uuid */
  customerId?: string;
  /** Feldname */
  field?: ScanDocumentRuleFieldTypeDto;
  /** @format uuid */
  id?: string;
  name?: string;
  value?: string;
}

export enum ShipmentProcessTypeDto {
  REGULAR = "REGULAR",
  STORAGE_TRANSFER = "STORAGE_TRANSFER",
  STORAGE_TRANSFER_SCA = "STORAGE_TRANSFER_SCA",
  STORAGE_TRANSFER_SCA_FINISH = "STORAGE_TRANSFER_SCA_FINISH",
  MVR_ON = "MVR_ON",
  MVR = "MVR",
}

export interface ShipmentReadyConfigurationDto {
  /** @format time */
  limes: string;
  shipmentType: ShipmentTypeDto;
  /**
   * One hour
   * @format duration
   * @example "PT1H"
   */
  waitBeforeReady?: string;
}

export enum ShipmentTypeDto {
  MORNING = "MORNING",
  LATE_MORNING = "LATE_MORNING",
  NOON = "NOON",
  TRACKED = "TRACKED",
}

export interface ShippingClientProjectionListDto {
  items: ShippingClientProjectionListItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface ShippingClientProjectionListItemDto {
  label: string;
  /** @format uuid */
  shippingClientId: string;
}

export interface ShippingConfigurationDto {
  /** @uniqueItems true */
  entries: ShippingConfigurationEntryDto[];
}

export interface ShippingConfigurationEntryDto {
  destinationType: ShippingDestinationTypeDto;
  processType: ShipmentProcessTypeDto;
  shipmentType: ShipmentTypeDto;
  /** @format uuid */
  shippingClientId: string;
}

export interface ShippingDefaultConfigurationDto {
  /** @uniqueItems true */
  entries: ShippingDefaultConfigurationEntryDto[];
}

export interface ShippingDefaultConfigurationEntryDto {
  destinationType: DefaultShippingDestinationTypeDto;
  processType: DefaultShipmentProcessTypeDto;
  shipmentType: DefaultShipmentTypeDto;
  /** @format uuid */
  shippingClientId: string;
}

export enum ShippingDestinationTypeDto {
  DOMESTIC = "DOMESTIC",
  EU = "EU",
  NON_EU = "NON_EU",
}

export interface StatisticsConfigurationDto {
  /** @format time */
  slaEndOfWorkday?: string;
}

export interface ValidationDto {
  fields?: FieldValidationDto[];
}

export interface WarehouseProjectionDto {
  name: string;
  /** @format uuid */
  warehouseId: string;
  warehouseNumber: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Customer Management Service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Cms<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Customer
     * @name ListCustomers
     * @summary Returns a list of customers
     * @request GET:/api/v1/customer
     * @secure
     */
    listCustomers: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerListDto, any>({
        path: `/api/v1/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CreateCustomer
     * @summary Creates a new customer
     * @request POST:/api/v1/customer
     * @secure
     */
    createCustomer: (data: CustomerDetailDto, params: RequestParams = {}) =>
      this.request<ResourceCreatedDto, any>({
        path: `/api/v1/customer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name ValidateCustomer
     * @summary Validates a customer
     * @request POST:/api/v1/customer/validation
     * @secure
     */
    validateCustomer: (
      data: CustomerDetailDto,
      query?: {
        validateCustomerNumber?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/customer/validation`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScanDocumentRule
     * @name ListScanDocumentRules
     * @summary Returns a list of scan document rules
     * @request GET:/api/v1/customer/{customerId}/scan-document-rule
     * @secure
     */
    listScanDocumentRules: (
      customerId: string,
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ScanDocumentRulesListDto, any>({
        path: `/api/v1/customer/${customerId}/scan-document-rule`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScanDocumentRule
     * @name CreateScanDocumentRule
     * @summary Creates a new scan document rule
     * @request POST:/api/v1/customer/{customerId}/scan-document-rule
     * @secure
     */
    createScanDocumentRule: (customerId: string, data: ScanDocumentRuleDataDto, params: RequestParams = {}) =>
      this.request<ResourceCreatedDto, any>({
        path: `/api/v1/customer/${customerId}/scan-document-rule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScanDocumentRule
     * @name ValidateScanDocumentRule
     * @summary Validates a scan document rule
     * @request POST:/api/v1/customer/{customerId}/scan-document-rule/validation
     * @secure
     */
    validateScanDocumentRule: (customerId: string, data: ScanDocumentRuleDetailDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/customer/${customerId}/scan-document-rule/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScanDocumentRule
     * @name GetScanDocumentRule
     * @summary Gets an existing scan document rule
     * @request GET:/api/v1/customer/{customerId}/scan-document-rule/{id}
     * @secure
     */
    getScanDocumentRule: (id: string, customerId: string, params: RequestParams = {}) =>
      this.request<ScanDocumentRuleDetailDto, any>({
        path: `/api/v1/customer/${customerId}/scan-document-rule/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScanDocumentRule
     * @name UpdateScanDocumentRule
     * @summary Updates an existing scan document rule
     * @request PUT:/api/v1/customer/{customerId}/scan-document-rule/{id}
     * @secure
     */
    updateScanDocumentRule: (
      id: string,
      customerId: string,
      data: ScanDocumentRuleDetailDto,
      params: RequestParams = {},
    ) =>
      this.request<ScanDocumentRuleDetailDto, any>({
        path: `/api/v1/customer/${customerId}/scan-document-rule/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetCustomer
     * @summary Gets an existing customer
     * @request GET:/api/v1/customer/{id}
     * @secure
     */
    getCustomer: (id: string, params: RequestParams = {}) =>
      this.request<CustomerDetailDto, any>({
        path: `/api/v1/customer/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name UpdateCustomer
     * @summary Updates an existing customer
     * @request PUT:/api/v1/customer/{id}
     * @secure
     */
    updateCustomer: (id: string, data: CustomerDetailDto, params: RequestParams = {}) =>
      this.request<CustomerDetailDto, any>({
        path: `/api/v1/customer/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetConfiguration
     * @summary Gets configuration of
     * @request GET:/api/v1/customer/{id}/configuration
     * @secure
     */
    getConfiguration: (id: string, params: RequestParams = {}) =>
      this.request<CustomerConfigurationDto, any>({
        path: `/api/v1/customer/${id}/configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name UpdateConfiguration
     * @summary Update configuration of
     * @request PUT:/api/v1/customer/{id}/configuration
     * @secure
     */
    updateConfiguration: (id: string, data: CustomerConfigurationDto, params: RequestParams = {}) =>
      this.request<CustomerConfigurationDto, any>({
        path: `/api/v1/customer/${id}/configuration`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name ValidateConfiguration
     * @summary Validate configuration of
     * @request POST:/api/v1/customer/{id}/configuration/validation
     * @secure
     */
    validateConfiguration: (id: string, data: CustomerConfigurationDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/customer/${id}/configuration/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetHistory
     * @summary Gets history of
     * @request GET:/api/v1/customer/{id}/history
     * @secure
     */
    getHistory: (id: string, params: RequestParams = {}) =>
      this.request<CustomerDetailDto[], any>({
        path: `/api/v1/customer/${id}/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Configuration Projection
     * @name ListShippingDefaultClients
     * @request GET:/api/v1/projection/shipping/default-clients
     * @secure
     */
    listShippingDefaultClients: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShippingClientProjectionListDto, any>({
        path: `/api/v1/projection/shipping/default-clients`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Configuration Projection
     * @name GetShippingDefaultConfiguration
     * @request GET:/api/v1/projection/shipping/default-configuration
     * @secure
     */
    getShippingDefaultConfiguration: (params: RequestParams = {}) =>
      this.request<ShippingDefaultConfigurationDto, any>({
        path: `/api/v1/projection/shipping/default-configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warehouse Projection
     * @name ListCustomerWarehouses
     * @summary Find all warehouses
     * @request GET:/api/v1/projection/warehouse
     * @secure
     */
    listCustomerWarehouses: (params: RequestParams = {}) =>
      this.request<WarehouseProjectionDto[], any>({
        path: `/api/v1/projection/warehouse`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
